// document.addEventListener('DOMContentLoaded', () => {
//   setTimeout(() => {
// const thumbnails = document.querySelectorAll('.thumbnail-list.list-unstyled.slider li button');
// const prevArrow = document.querySelector('.thumbnail-slider .slider-button.slider-button--prev');
// const nextArrow = document.querySelector('.thumbnail-slider .slider-button.slider-button--next');

//     prevArrow.removeAttribute('disabled');
  
//     nextArrow.removeAttribute('disabled');
   


// // Function to update the active thumbnail by aria-current
// function updateActiveThumbnail(newIndex) {
//   // Remove aria-current from the current thumbnail
//   const currentActive = document.querySelector('.thumbnail-list.list-unstyled.slider li button[aria-current="true"]');
//   if (currentActive) currentActive.removeAttribute('aria-current');

//   // Add aria-current to the new thumbnail
//   thumbnails[newIndex].setAttribute('aria-current', 'true');
// }

// // Event listener for previous arrow
// prevArrow.addEventListener('click', () => {

//   const currentIndex = [...thumbnails].findIndex(thumb => thumb.getAttribute('aria-current') === 'true');
//   if (currentIndex === -1) {
//     console.error('No active thumbnail found.');
//     return;
//   }

//   const prevIndex = (currentIndex - 1 + thumbnails.length) % thumbnails.length; // Wrap around
//   updateActiveThumbnail(prevIndex);

//   // Simulate click on the new active thumbnail
//   thumbnails[prevIndex].click();
// });

// // Event listener for next arrow
// nextArrow.addEventListener('click', () => {

//   const currentIndex = [...thumbnails].findIndex(thumb => thumb.getAttribute('aria-current') === 'true');
//   if (currentIndex === -1) {
//     console.error('No active thumbnail found.');
//     return;
//   }

//   const nextIndex = (currentIndex + 1) % thumbnails.length; // Wrap around
//   updateActiveThumbnail(nextIndex);

//   // Simulate click on the new active thumbnail
//   thumbnails[nextIndex].click();
// });


//     }, 1500);


  


// });



// document.addEventListener("DOMContentLoaded", function () {
//   if (document.querySelectorAll(".video-item").length > 0){
//     const videoItems = document.querySelectorAll(".video-item");
//   const popup = document.getElementById("videoPopup");
//   const popupVideo = document.getElementById("popupVideo");
//   const popupSource = popupVideo.querySelector("source");
//   const closeBtn = document.getElementById("closePopup");

//   // Open popup with the clicked video's src
//   videoItems.forEach((video) => {
//     video.addEventListener("click", function () {
//       const videoSrc = this.querySelector("source").getAttribute("src");
//       popupSource.setAttribute("src", videoSrc);
//       popupVideo.load(); // Reload the video with the new source
//       popup.style.display = "flex"; // Show the popup
//       popupVideo.play(); // Autoplay the video in the popup
//     });
//   });

//   // Close the popup and pause the video
//   closeBtn.addEventListener("click", function () {
//     popup.style.display = "none"; // Hide the popup
//     popupVideo.pause(); // Pause the video
//     popupSource.setAttribute("src", ""); // Remove the source to reset the video
//     popupVideo.load(); // Reset the video player
//   });

//   // Optional: Close the popup when clicking outside the video
//   popup.addEventListener("click", function (e) {
//     if (e.target === popup) {
//       popup.style.display = "none";
//       popupVideo.pause();
//       popupSource.setAttribute("src", "");
//       popupVideo.load();
//     }
//   });
//   }
  
// });






// document.addEventListener('DOMContentLoaded', function() {
//   // Find all thumbnail sliders on the page
//   const thumbnailSliders = document.querySelectorAll('slider-component.thumbnail-slider');
  
//   // Initialize each slider
//   thumbnailSliders.forEach(thumbnailSlider => {
//     const thumbnailList = thumbnailSlider.querySelector('.thumbnail-list');
//     const prevButton = thumbnailSlider.querySelector('.slider-button--prev');
//     const nextButton = thumbnailSlider.querySelector('.slider-button--next');
//     const thumbnails = thumbnailSlider.querySelectorAll('.thumbnail-list__item');
    
//     if (!thumbnailList || !prevButton || !nextButton) return;
    
//     // Check if mobile view (assuming <= 768px is mobile)
//     const isMobile = () => window.innerWidth <= 768;
    
//     // Scroll to active thumbnail
//     function scrollToActiveThumbnail() {
//       const activeThumbnail = thumbnailSlider.querySelector('.thumbnail-list__item [aria-current="true"]')?.closest('.thumbnail-list__item');
//       if (activeThumbnail) {
//         const containerRect = thumbnailList.getBoundingClientRect();
//         const thumbRect = activeThumbnail.getBoundingClientRect();
        
//         if (isMobile()) {
//           // Horizontal scrolling for mobile
//           const scrollPosition = thumbRect.left - containerRect.left + thumbnailList.scrollLeft - (containerRect.width / 2) + (thumbRect.width / 2);
//           thumbnailList.scrollTo({
//             left: scrollPosition,
//             behavior: 'smooth'
//           });
//         } else {
//           // Vertical scrolling for desktop
//           const scrollPosition = thumbRect.top - containerRect.top + thumbnailList.scrollTop - (containerRect.height / 2) + (thumbRect.height / 2);
//           thumbnailList.scrollTo({
//             top: scrollPosition,
//             behavior: 'smooth'
//           });
//         }
//       }
//     }
    
//     // Update arrow buttons state
//     function updateArrowButtons() {
//       if (isMobile()) {
//         // Horizontal scrolling for mobile
//         const scrollLeft = thumbnailList.scrollLeft;
//         const maxScroll = thumbnailList.scrollWidth - thumbnailList.clientWidth;
//         prevButton.disabled = scrollLeft <= 0;
//         nextButton.disabled = scrollLeft >= maxScroll;
//       } else {
//         // Vertical scrolling for desktop
//         const scrollTop = thumbnailList.scrollTop;
//         const maxScroll = thumbnailList.scrollHeight - thumbnailList.clientHeight;
//         prevButton.disabled = scrollTop <= 0;
//         nextButton.disabled = scrollTop >= maxScroll;
//       }
//     }
    
//     // Handle thumbnail click
//     thumbnails.forEach(thumb => {
//       thumb.addEventListener('click', function() {
//         setTimeout(scrollToActiveThumbnail, 50);
//       });
//     });
    
//     // Arrow button functionality
//     prevButton.addEventListener('click', function() {
//       if (isMobile()) {
//         // Horizontal scrolling for mobile
//         thumbnailList.scrollBy({
//           left: -100,
//           behavior: 'smooth'
//         });
//       } else {
//         // Vertical scrolling for desktop
//         thumbnailList.scrollBy({
//           top: -100,
//           behavior: 'smooth'
//         });
//       }
//     });
    
//     nextButton.addEventListener('click', function() {
//       if (isMobile()) {
//         // Horizontal scrolling for mobile
//         thumbnailList.scrollBy({
//           left: 100,
//           behavior: 'smooth'
//         });
//       } else {
//         // Vertical scrolling for desktop
//         thumbnailList.scrollBy({
//           top: 100,
//           behavior: 'smooth'
//         });
//       }
//     });
    
//     // Update on scroll
//     thumbnailList.addEventListener('scroll', updateArrowButtons);
    
//     // Initialize
//     scrollToActiveThumbnail();
//     updateArrowButtons();
    
//     // Observe for changes in the active thumbnail (for Shopify galleries)
//     const observer = new MutationObserver(function(mutations) {
//       mutations.forEach(function(mutation) {
//         if (mutation.attributeName === 'aria-current') {
//           scrollToActiveThumbnail();
//         }
//       });
//     });
    
//     // Observe all thumbnails for aria-current changes
//     thumbnails.forEach(thumb => {
//       observer.observe(thumb, { attributes: true });
//     });
    
//     // Also observe the thumbnail buttons inside each item
//     thumbnails.forEach(thumb => {
//       const button = thumb.querySelector('button');
//       if (button) {
//         observer.observe(button, { attributes: true });
//       }
//     });
    
//     // Update on window resize to handle mobile/desktop switch
//     window.addEventListener('resize', function() {
//       scrollToActiveThumbnail();
//       updateArrowButtons();
//     });
//   });
// });


// jQuery(document).ready(function($) {
//   $('.thumbnail-list').slick({
//     dots: false,
//     arrows: true,
//     infinite: true,
//     slidesToShow: 5,     
//     slidesToScroll: 1,
//     autoplay: false,
//     autoplaySpeed: 2000,
//     vertical: true,       
//     responsive: [
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 1, 
//           vertical: false  
//         }
//       }
//     ]
//   });
// });



jQuery(document).ready(function($) {
  function handleSlick() {
    const $slider = $('.thumbnail-list');

    if ($(window).width() < 768) {
      // Unslick on mobile if initialized
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
    } else {
      // Initialize on desktop if not initialized
      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
          dots: false,
          arrows: true,
          infinite: true,
          slidesToShow: 5,
          slidesToScroll: 1,
          autoplay: false,
          vertical: true
        });
      }
    }
  }

  // Run on page load
  handleSlick();

  // Recheck on window resize
  $(window).on('resize', function() {
    handleSlick();
  });
});

